import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/reducers/root.reducer'

interface IPublicRoute {
  component: React.FC
  path: string
  exact: boolean
}

const PublicRoute: React.FC<IPublicRoute> = ({ component, path, exact }) => {
  const isAuth = useSelector((state: RootState) => state.user.is_auth)

  return isAuth ? (
    <Redirect to="/crm-leads" />
  ) : (
    <Route path={path} exact={exact} component={component} />
  )
}

export default PublicRoute
